export default __webpack_public_path__ + "static/media/creature.b771f4a0.svg";